import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function BlogPage() {
  const [posts, setPosts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    api.get("/blog").then((r) => {
      setPosts(r.data);
      setLoading(false);
    });
  }, []);

  const [feat, ...rest] = posts;

  return (
    <div data-testid="blog-page">
      <section className="relative py-20 sm:py-28 overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,165,233,0.15),transparent_55%)]" />
        <div className="mfb-container relative">
          <div className="overline mb-4">Insights & Research</div>
          <h1 className="font-[Outfit] text-5xl sm:text-6xl font-light tracking-tighter text-white max-w-3xl">
            Notes from the <span className="gradient-text-sky">MFB research desk</span>.
          </h1>
        </div>
      </section>

      <section className="mfb-section pt-0">
        <div className="mfb-container">
          {loading ? (
            <div className="text-slate-400 text-sm">Loading…</div>
          ) : (
            <>
              {feat && (
                <Link to={`/blog/${feat.slug}`} className="card-luxury grid md:grid-cols-2 gap-0 overflow-hidden group" data-testid="blog-featured">
                  {feat.cover_image && (
                    <div className="aspect-[16/10] md:aspect-auto overflow-hidden">
                      <img src={feat.cover_image} alt={feat.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                  )}
                  <div className="p-8 sm:p-10 flex flex-col justify-center">
                    <Badge className="bg-sky-500/10 text-sky-300 border-sky-500/20 w-fit hover:bg-sky-500/15">{feat.category}</Badge>
                    <h2 className="mt-4 font-[Outfit] text-3xl sm:text-4xl text-white font-light leading-tight">{feat.title}</h2>
                    <p className="mt-3 text-slate-400 text-sm leading-relaxed">{feat.excerpt}</p>
                    <div className="mt-6 flex items-center gap-3 text-slate-500 text-xs">
                      <span>{feat.author}</span>
                      <span>·</span>
                      <span>{new Date(feat.created_at).toLocaleDateString()}</span>
                    </div>
                  </div>
                </Link>
              )}

              <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {rest.map((p) => (
                  <Link key={p.id} to={`/blog/${p.slug}`} className="card-luxury overflow-hidden group" data-testid={`blog-card-${p.slug}`}>
                    {p.cover_image && (
                      <div className="aspect-[16/10] overflow-hidden">
                        <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                      </div>
                    )}
                    <div className="p-6">
                      <Badge className="bg-sky-500/10 text-sky-300 border-sky-500/20 hover:bg-sky-500/15">{p.category}</Badge>
                      <h3 className="mt-3 text-white font-[Outfit] text-lg leading-snug">{p.title}</h3>
                      <p className="mt-2 text-slate-400 text-sm leading-relaxed line-clamp-2">{p.excerpt}</p>
                      <div className="mt-4 flex items-center text-sky-400 text-xs">
                        Read <ArrowRight className="w-3.5 h-3.5 ml-1" />
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
